module.exports = __webpack_public_path__ + "img/91234979.49433255.png";